/**
 * Audit Service
 *
 * Stamps record metadata (`inclusionDate` / `lastModifiedDate`, and — when a
 * user id is supplied — `inclusionUserId` / `lastModifiedUserId`). Pure
 * TypeScript, shared by web + mobile. Call from the domain write paths so the
 * metadata can't be forgotten.
 *
 * The `userId` option is **reserved**: pass it once the current-user id is
 * threaded into the domain calls. Until then only the dates are stamped.
 */
import { auditContext } from './auditContext.js';
class AuditService {
    /** Stamp creation metadata: inclusion + last-modified both = now. */
    stampOnCreate(entity, opts = {}) {
        const now = opts.now ?? new Date();
        const userId = opts.userId ?? auditContext.getUserId();
        return {
            ...entity,
            inclusionDate: now,
            lastModifiedDate: now,
            ...(userId ? { inclusionUserId: userId, lastModifiedUserId: userId } : {}),
        };
    }
    /** Stamp update metadata: refresh last-modified (+ user when available). */
    stampOnUpdate(entity, opts = {}) {
        const now = opts.now ?? new Date();
        const userId = opts.userId ?? auditContext.getUserId();
        return {
            ...entity,
            lastModifiedDate: now,
            ...(userId ? { lastModifiedUserId: userId } : {}),
        };
    }
}
export const auditService = new AuditService();
//# sourceMappingURL=auditService.js.map